import { useEffect, useRef, useState } from "react";
import "./style.css";

import api, {MENSAGEM_ERRO_HTTP} from "../../services/api";
import InputMask from "react-input-mask";
import { Oval } from  "react-loader-spinner";
import { SelecionaPaciente } from "./paciente";
import { SelecionaPrioritario } from "./prioritario";
import { Loading } from "../Routes";

import { validaCPF, mensagemErro, mensagemSucesso, dateNowBR, timeNow, getParam } from "../../library";

function handleReset(removeTipoFilaAtendimento = true) {
    if (removeTipoFilaAtendimento) {
        localStorage.removeItem("filaAtendimento");
    }

    window.location.reload(false);
}

export const VoltaInicio = ({ filaAtendimento, handleLoading } ) => {
    return (
        filaAtendimento && filaAtendimento?.nome 
        ? <button className="home-volta-inicio" onClick={() => {handleLoading(); handleReset();}}>Volta para o início</button>
        : null
    );
}

export const TipoFilaAtendimento = ({ codlocal }) => {
    const [tipoFilaAtendimentoList, setTipoFilaAtendimentoList] = useState([]);

    function toggleTipoFilaAtendimento(tipo) {
        tipo.now = String(new Date());
        localStorage.setItem("filaAtendimento", JSON.stringify(tipo));
        handleReset(false);
    }

    useEffect(() => {
        api.get("/lista-tipo-fila-atendimento")
        .then(response => response.data)
        .then(response => setTipoFilaAtendimentoList(response.list))
        .catch(() => MENSAGEM_ERRO_HTTP());
    }, []);    

    return (
        <div className="home-container">
            <div className="home-tipo-fila-content">
                {/* <h2 style={{position: "sticky", top: 0}}>Selecione a opção desejada</h2> */}

                <div className="home-tipo-fila-lista">
                    {
                        tipoFilaAtendimentoList?.map(tipo => {
                            return (
                                <div key={tipo.tipo} className="home-tipo-fila-lista-item" onClick={() => toggleTipoFilaAtendimento(tipo)}>
                                    <span>{tipo.nome}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export const FilaAtendimento = ({ codlocal, filaAtendimento }) => {
    const [loading, setLoading] = useState(false);
    const [intervalResetID, setIntavalResetID] = useState(null);
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [cpf, setCPF] = useState(""); //00915425025
    const [nome, setNome] = useState("");
    const [selecionaPaciente, setSelecionaPaciente] = useState(false);
    const [selecionaPrioritario, setSelecionaPrioritario] = useState(false);    
    const [pacienteList, setPacienteList] = useState([]);
    const cpfRef = useRef(null);

    const onChangeInputCPF = event => {
        let input = event.target.value;
        input = input?.substring(0, 14);
        setCPF(input);
    };     

    function handleClearTimeoutReset() {
        return;
        clearTimeout(intervalResetID);
        setIntavalResetID(null);
    }

    function handleSetTimeoutReset(timeout) {
        return;
        let id = setTimeout(() => {handleReset()}, timeout ? timeout : 30000);

        setIntavalResetID(id);
    }

    async function handleValidaFilaAtendimento(codpaciente) {       
        setLoading(true);
        handleClearTimeoutReset();

        try {
            let response = await (await api.post(
                "/valida-fila-atendimento", 
                {
                    codlocal: codlocal,
                    cpf: cpf,
                    codpaciente: codpaciente ? codpaciente : ""
                }
            )).data;

            if (response.error) {
                switch (response?.errorCode) {
                    case 1: //Paciente já está na fila de hoje
                        handleSetTimeoutReset(8000);

                        if (response?.messageName)
                            mensagemErro(
                                "", 
                                `
                                    <div class="swal2-html-container">
                                        <span><b>${response.messageName}</b>, ${response.messageText}</span>
                                    </div>
                                `, 
                                true,
                                handleReset
                            );
                        else
                            mensagemErro(response?.message, "", false, handleReset);
                        break;
                    
                    case 2: //CPF tem mais de 1 paciente, usuário seleciona
                        handleSetTimeoutReset(15000);
                        setPacienteList(response?.pacienteList);
                        setSelecionaPaciente(true);
                        break;
                }
            } else {
                setSelecionaPaciente(false);
                setLoading(false);
                handleIncluiFilaAtendimento(response?.codpaciente, false);
            }
        } catch {
            handleSetTimeoutReset();
            setLoading(false);
            MENSAGEM_ERRO_HTTP();
        } finally {
            //setLoading(false);
        }
    }

    async function handleIncluiFilaAtendimento(codpaciente, prioritario) {
        setLoading(true);
        handleClearTimeoutReset();

        try {       
            let response = await (await api.post(
                "/inclui-fila-atendimento", 
                {
                    codlocal: codlocal, 
                    cpf: validaCPF(cpf) ? cpf : "",
                    codpaciente: codpaciente ? codpaciente : "",
                    prioritario: prioritario,
                    tipoFilaAtendimento: filaAtendimento?.tipo ? filaAtendimento?.tipo : "",
                    origem: "SITE" 
                }
            )).data;

            if (response.error) {
                handleSetTimeoutReset(6000);

                if (response.message)
                    mensagemErro(response.message, "", false, handleReset);
                else
                    MENSAGEM_ERRO_HTTP();
            } else {
                handleSetTimeoutReset(6000);

                if (response?.messageName)
                    mensagemSucesso(
                        "", 
                        `
                            <div class="swal2-html-container">
                                <span><b>${response.messageName}</b>, ${response.messageText}</span>
                            </div>
                        `,
                        true,
                        handleReset
                    );
                else if (response?.name) {
                    mensagemSucesso(response.name, response.message, false, handleReset);
                } else {
                    mensagemSucesso(response.message, "", false, handleReset);
                }
            }
        } catch {
            handleSetTimeoutReset();
            setLoading(false);
            MENSAGEM_ERRO_HTTP();
        } finally {
            //setLoading(false);
        }
    }

    useEffect(() => {
        handleClearTimeoutReset();

        if (cpf) {
            handleSetTimeoutReset();
        }
    }, [cpf]);

    useEffect(() => {
        const interval = setInterval(() => {
            setDate(dateNowBR());
            setTime(timeNow(false));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="home-container"> 
            <SelecionaPaciente isOpen={selecionaPaciente} onRequestClose={() => setSelecionaPaciente(false)} data={pacienteList} handleValidaFilaAtendimento={(codpaciente) => handleValidaFilaAtendimento(codpaciente)} handleIncluiFilaAtendimento={handleIncluiFilaAtendimento} mostraTopo={true} />
            <SelecionaPrioritario isOpen={selecionaPrioritario} onRequestClose={() => setSelecionaPrioritario(false)} handleIncluiFilaAtendimento={handleIncluiFilaAtendimento} mostraTopo={false} />            

            <div className="home-content">
                {
                    filaAtendimento?.nome
                    ? <span className="home-fila-atendimento">{filaAtendimento?.nome}</span>
                    : null
                }        

                <div 
                    className="home-content-keyboard" 
                    style={{
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.4 : 1
                    }
                }>
                    <InputMask 
                        ref={cpfRef}
                        style={{color: validaCPF(cpf) ? "green" : "orangered"}}
                        className="home-input-cpf"
                        value={cpf}
                        onChange={onChangeInputCPF}
                        disabled={false}
                        placeholder="Informe o CPF do paciente"
                        mask="999.999.999-99"
                    />                   
                

                    <div className="home-content-acao">                   
                        {
                            loading
                            ? <Oval
                                height={60}
                                width={60}
                                color="#1e90ff"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#1e90ff"
                                strokeWidth={3}
                                strokeWidthSecondary={3}
                            />
                            
                            :
                                validaCPF(cpf)
                                ? <button className="home-confirma" onClick={() => handleValidaFilaAtendimento()}>Confirma</button>
                                : <button className="home-sem-cpf" onClick={() => setSelecionaPrioritario(true)}>Não sei o CPF</button> 
                        }
                    </div>   
                </div>

                <div className="home-content-volta-inicio">
                    {
                        loading ? null : <VoltaInicio filaAtendimento={filaAtendimento} handleLoading={() => setLoading(true)} />
                    }
                </div>             
            </div>
        </div>
    );  
};

const IncluiFilaAtendimento = () => {
    const [codLocal, setCodLocal] = useState(null);
    const [tipoFilaAtendimento, setTipoFilaAtendimento] = useState(null);

    useEffect(() => {
        let local = getParam("codLocal");
        let filaAtendimento = JSON.parse(localStorage.getItem("filaAtendimento"));
        let now = new Date();
        let old = new Date(filaAtendimento?.now);
        let diffMinutes = now.getMinutes() - old.getMinutes(); 
        diffMinutes = Math.abs(diffMinutes);
       
        if (diffMinutes > 0) {
            localStorage.removeItem("filaAtendimento");
            filaAtendimento = [];
        }

        if (filaAtendimento && filaAtendimento?.tipo) 
            setTipoFilaAtendimento(filaAtendimento);  

        if (local) 
            setCodLocal(parseInt(local));
        else    
            setCodLocal(-1);      
    }, [])

    if (codLocal === null)
        return <Loading />

    if (tipoFilaAtendimento)
        return <FilaAtendimento codlocal={codLocal} filaAtendimento={tipoFilaAtendimento} />
    else
        return <TipoFilaAtendimento />
};

export default IncluiFilaAtendimento;